import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';

interface IProps {
  jsonQuery: IJsonQuery;
  timeInMilliseconds: number;
  startTimestamp: number;
  deviceType: TDeviceType | undefined;
  queryString: string;
}

export function trackPrematurePinLoad({
  jsonQuery,
  deviceType,
  timeInMilliseconds,
  startTimestamp,
  queryString,
}: IProps) {
  ca('eventSite', {
    event: 'oldevent',
    name: 'oldevent',
    category: 'Map',
    action: 'long_time_sopr',
    label: String(timeInMilliseconds),
    page: {
      pageType: 'Map',
      siteType: deviceType === 'desktop' ? 'desktop' : 'mobile',
      queryString,
      extra: {
        requestStartTimestamp: String(startTimestamp),
      },
    },
    sc: jsonQuery,
  });
}
